// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__niUv8","childrenWrapper":"Icon_childrenWrapper__MWrf9"};